module.exports = __webpack_public_path__ + "static/img/play-singleplayer.8c3bf12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/play-singleplayer.jpg
// module id = dAsO
// module chunks = 1